import {
  Button,
  Card,
  Col,
  Container,
  ProgressBar,
  Row,
} from "react-bootstrap";
import BackButton from "../../../shared/BackButton";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import useLegacyEffect from "../../../hooks/useLegacyEffect";
import formatDate from "../../../utils/formatDate";
import { currenOrdersStatus } from "../../../lookups/status";
import { fetchConsultationRequest } from "../../../store/Consultation/actions";

function OrderDetails() {
  const navigate = useNavigate();
  let { companyId, uuid } = useParams();
  const dispatch = useDispatch();
  const local = useSelector((state) => state.homeReducer.local);
  const isRTL = local.isAr;
  const consultationRequest = useSelector(
    (state) => state.consultationReducer.consultationRequest
  );
  const formattedDate = formatDate(consultationRequest?.created_at, "date");
  const currenOrdersStatusObj = currenOrdersStatus(local).find(
    (element) => element?.id === consultationRequest?.status
  );

  useLegacyEffect(() => {
    dispatch(fetchConsultationRequest(uuid));
  }, []);
  const now = +consultationRequest.completed_hours;
  const max = +consultationRequest.total_hours;
  const percent = (now / max) * 100;
  const downloadReport = (report) => {
    const link = document.createElement("a");
    link.href = report.document;
    link.download = report.file_name;
    link.target = "_blank";
    link.click();
  };
  return (
    <Container className="order-details">
      <BackButton onClick={() => navigate(-1)} label={local.backV2} />
      <h1 className="mb-4 fs-3">{consultationRequest.package}</h1>
      {consultationRequest.id === uuid && (
        <>
          <Row className="my-2">
            <Col xs={6} md={2}>
              <p className="mb-0">{local.orderDate}</p>
              <p className="fs-4 text-success">{formattedDate}</p>
            </Col>
            <Col xs={6} md={6}>
              <p className="mb-0">{local.status}</p>
              <p className="fs-4 text-success">
                {currenOrdersStatusObj?.status}
              </p>
            </Col>
          </Row>
          <p className="text-success fs-4 fw-bold">{local.consultingHours}</p>
          <Card className="shadow-lg p-5">
            <div className="progressbar-custom-container">
              {/* ProgressBar */}
              <ProgressBar
                now={percent}
                className="progressbar-custom-progress rounded-pill"
                variant="success"
              />
              {/* Now value box */}
              <div
                className="progressbar-now-box position-absolute text-center fs-4 text-white fw-bold bg-success"
                style={{
                  top: "16px",
                  [isRTL ? "right" : "left"]: `calc(${percent}% - 10px)`,
                }}
              >
                {now}
              </div>
              {/* Now label below */}
              <div
                className="progressbar-now-label text-center text-success fw-bold position-absolute fs-6 lh-1"
                style={{
                  top: "58px",
                  [isRTL ? "right" : "left"]: `calc(${percent}% - 20px)`,
                }}
              >
                {local.completedHours}
              </div>
              {/* Max value box */}
              {+consultationRequest.completed_hours !==
                +consultationRequest.total_hours && (
                <div
                  className="progressbar-max-box text-center fs-4 position-absolute"
                  style={{
                    top: "54%",
                    transform: "translateY(-50%)",
                    [isRTL ? "left" : "right"]: "0",
                  }}
                >
                  {max}
                </div>
              )}
            </div>
          </Card>
          <p className="text-success fs-4 fw-bold pt-5">
            {local.reportsToImprove}
          </p>
          <Card className="shadow p-5">
            {consultationRequest?.reports?.length > 0 ? (
              <div>
                <div className="grid d-none d-md-grid">
                  <p className="g-col-3 mb-0 fw-bold">{local.orderType}</p>
                  <p className="g-col-3 mb-0 fw-bold">{local.orderDate}</p>
                  <p className="g-col-3 mb-0 fw-bold"></p>
                </div>
                <hr className="d-none d-md-block my-0" />
                {consultationRequest?.reports.map((report, index) => {
                  return (
                    <div key={index}>
                      <Card className="grid inner_card shadow p-4 my-3 my-md-0 align-items-center">
                        <p className="fs-5 mb-0 g-col-12 g-col-md-3">
                          <span className="d-inline-block d-md-none text-primary mx-1">
                            {local.orderType} :
                          </span>
                          {report.type !== "remote"
                            ? local.personalConsultationReport
                            : local.remoteConsultationReport}
                        </p>
                        <p className="fs-5 mb-0 g-col-12 g-col-md-3">
                          <span className="d-inline-block d-md-none text-primary mx-1">
                            {local.orderDate} :
                          </span>
                          {formatDate(report?.created_at, "date")}
                        </p>
                        <p className="fs-5 mb-0 g-col-12 g-col-md-3"></p>
                        <p className="fs-5 mb-0 g-col-12 g-col-md-3">
                          <Button
                            variant="success"
                            onClick={() => downloadReport(report)}
                            className="w-100 mt-3 text-white"
                          >
                            <i className="bi bi-download ms-2 "></i>
                            {local.reportDownload}
                          </Button>
                        </p>
                      </Card>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-center">{local.noReportsAvailable}</p>
            )}
          </Card>
        </>
      )}
    </Container>
  );
}

export default OrderDetails;
